var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"900px","height":"1500px","padding-left":"250px","border":"1px solid rgb(102 102 102)"},attrs:{"id":"main"}})}
var staticRenderFns = []

export { render, staticRenderFns }